






















import { defineComponent, PropType, ref } from '@vue/composition-api';
import { ReactionType } from '@front-app/services/GroupsApi/DiscussionModel';
import { Size } from '@front-app/components/constants';

export default defineComponent({
	props: {
		count: {
			type: Number,
			default: 0,
		},
		icon: {
			type: String,
			required: true,
		},
		size: {
			type: String as PropType<Size>,
			default: Size.MEDIUM,
		},
		type: {
			type: String as PropType<ReactionType>,
			required: true,
		},
		displayCount: Boolean,
		displayDefaultBorder: Boolean,
		hasCurrentUserReacted: Boolean,
	},
	setup() {
		const isFocused = ref(false);

		return {
			isFocused,
			ReactionType,
			Size,
		};
	},
});
